/*
**  文章页中，唤起客户端新闻页面
*/

var CallHuyouAapp = (function() {
    // 调起分享到狐友
    function shareToHuYou({
            appNewsPageUrl = '',
            image = '',
            title = '',
        }) {
        window.backflow && backflow.init();
        let protocol = `sohuhy://w.sohu.com/shareToNative?type=1&appid=10005&appkey=J0O5Ov0K~!xM30B1&appName=${encodeURIComponent(
            "手机搜狐网"
          )}&title=${encodeURIComponent(
                title
          )}&url=${encodeURIComponent(
                appNewsPageUrl
          )}&thumbUrl=${encodeURIComponent(
                image
          )}&referId=${Date.now()}`
          window.backflow && backflow.callHuyou(protocol)
    }
    return {
        shareToHuYou:shareToHuYou
    }
})();

export default CallHuyouAapp;